import { Heading, Img, TestimonialCard } from '@okam/brand-ui/index'
import { useHtml2React } from '@okam/html2react/provider'
import { useTranslation } from 'next-i18next'
import tw, { css } from 'twin.macro'
import { useFragment } from 'gql'
import withForwardedRefSection from 'lib/utils/withForwardedRefSection'
import { blockStoriesFragment, colorSchemeFragment } from 'query/single-page/fragment'
import type { TPetParentsCornerStoriesBlock } from '../../types'

/* eslint-disable-next-line react/display-name */
const StoriesPetParentsCornerBlock = (props: TPetParentsCornerStoriesBlock) => {
  const { title, colors, stories } = useFragment(blockStoriesFragment, props)
  const { t } = useTranslation('common')

  const blockColors = useFragment(colorSchemeFragment, colors)

  const { parseHTMLToReact } = useHtml2React()

  return (
    <div
      css={[
        css`
          ${blockColors?.background ? `background-color: ${blockColors?.background}` : tw`bg-primary-1`}
          ${tw`relative flex flex-col font-semibold py-32 overflow-hidden`}
        `,
      ]}
    >
      <div>
        <div tw="flex flex-col px-6 md:px-20 relative overflow-hidden">
          {title && (
            <Heading as="h2" variant="h1">
              {parseHTMLToReact(title)}
            </Heading>
          )}

          <div tw="relative z-[2] flex w-full flex-col h-full items-center md:items-stretch gap-12 py-6 md:pt-16 md:flex-row">
            {stories?.map((story) => {
              const storyInfo = story?.storiesId
              const storyPicture = storyInfo?.picture

              return (
                <TestimonialCard
                  key={storyInfo?.id}
                  title={storyInfo?.petName ?? ''}
                  footnote={storyInfo?.footnote ?? ''}
                  bgColor={storyInfo?.backgroundColor ?? ''}
                  text={storyInfo?.content ?? ''}
                >
                  <Img
                    tw="object-cover"
                    alt={storyPicture?.description ?? ''}
                    fill
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    id={storyPicture?.id}
                    filename={storyPicture?.filenameDownload}
                  />
                </TestimonialCard>
              )
            })}
          </div>
        </div>
      </div>
      <div tw="z-[1] absolute right-0 w-1/5 h-full -translate-y-32 overflow-hidden opacity-25">
        <Img
          tw="object-cover h-full"
          src="/shared-assets/images/texture-stories.png"
          priority
          alt={t('IMAGE.TEXTURE')}
          width={1200}
          height={1200}
        />
      </div>
    </div>
  )
}

export default withForwardedRefSection<TPetParentsCornerStoriesBlock>(StoriesPetParentsCornerBlock)
